export default __webpack_public_path__ + "static/media/Member_ID_Card.1c332f75.jpg";